import React from 'react';
import { Modal } from 'react-bootstrap';

/**
 * The one dialog shell for the settings surfaces.
 *
 * The Automatisering modals were plain react-bootstrap defaults — square-ish
 * corners, a white header with no band, a bare footer — while the modals a
 * click away in Användare had already been given the card language. Same
 * product, two eras.
 *
 * This is `modern-card` in dialog form: grey header band with a 16px icon and
 * a 1rem title, white body, footer separated by a rule. Anything Modal accepts
 * still passes through.
 */
const SettingsModal = ({
  show,
  onHide,
  icon: Icon,
  title,
  // Buttons for the footer. Omitted = no footer, for dialogs that are purely
  // informational.
  footer,
  // Locked shut while something is in flight.
  closeButton = true,
  size,
  children,
  ...rest
}) => (
  <Modal
    show={show}
    onHide={onHide}
    centered
    size={size}
    dialogClassName="settings-modal"
    {...rest}
  >
    <Modal.Header closeButton={closeButton}>
      <Modal.Title>
        {Icon && <Icon size={16} aria-hidden="true" />}
        {title}
      </Modal.Title>
    </Modal.Header>

    <Modal.Body>{children}</Modal.Body>

    {footer && <Modal.Footer>{footer}</Modal.Footer>}
  </Modal>
);

export default SettingsModal;
